import { render } from "./ClaimsAnalytics.vue?vue&type=template&id=89d27a96"
import script from "./ClaimsAnalytics.vue?vue&type=script&lang=js"
export * from "./ClaimsAnalytics.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__